<form nz-form [formGroup]="timesheetSearchForm">
  <div nz-row gutter="16" style="display: flex; flex-wrap: wrap; align-items: flex-end; width: 100%">

    <!-- Filter Items -->

    <div nz-col *ngIf="timesheetSearchForm.controls['Timeframe']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Timeframe'">
          <div style="width: 100%;" class="filters">
            <ppl-dropdown-select formControlName="Timeframe" id="Timeframe" placeholder="Timeframe"
            [options]="loopback" [optionLabel]="'label'" [optionValue]="'val'">
            </ppl-dropdown-select>
          </div>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['status']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3"
      [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a status'">
          <div style="width: 100%;" class="filters">
            <ppl-dropdown-select formControlName="status" id="status" placeholder="Status"
            [options]="statusList" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
            </ppl-dropdown-select>
          </div>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['processStatusLkp']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Process Status'">
          <div style="width: 100%;" class="filters">
            <ppl-dropdown-select formControlName="processStatusLkp"  id="ProcessStatus"
            placeholder="Process Status" [options]="processStatusList" [optionLabel]="'lkpValueName'"
            [optionValue]="'lkpValueCode'">
            </ppl-dropdown-select>
          </div>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['processStatusLkup']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Process Status'">
          <div style="width: 100%;" class="filters">
            <ppl-dropdown-select formControlName="processStatusLkup" id="ProcessStatus"
              placeholder="Process Status" [options]="filteredProcessStatusList"
              [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
            </ppl-dropdown-select>
          </div>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['serviceDate']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a service date'">
          <!-- <nz-date-picker formControlName="serviceDate" id="serviceDate" nzPlaceHolder="Service Date"
            [nzFormat]="'MM/dd/yyyy'" nzShowSearch nzAllowClear style="width: 100%; height: 32px"></nz-date-picker> -->
          <ppl-date-picker formControlName="serviceDate" [id]="'serviceDate'" [showIcon]="true"
            [placeholder]="'Service Date'" dateFormat="mm/dd/yy" [yearRange]="'1900:2050'" [iconDisplay]="'input'"
            inputId="icondisplay" [panelStyleClass]="'custom-calendar-panel'">
          </ppl-date-picker>
        </nz-form-control>
      </nz-form-item>
    </div>

    @if(payPeriodMultipleSelection === 'multiple') {
    <div nz-col *ngIf="timesheetSearchForm.controls['payPeriod']" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="6" [nzXXl]="6" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a service period'">
          <ppl-multiselect formControlName="payPeriod" id="payPeriod" class="filters" [ariaLabel]="'Service Period'" [options]="payPeriod" [disabled]="false"
          [showClear]="true" [placeholder]="'Service Period'" [optionLabel]="'payPeriod'" style="width: 100%;"
          [optionValue]="'payrollId'" [maxTagCount]="1">
        </ppl-multiselect>
        </nz-form-control>
      </nz-form-item>
    </div>
    } @else {
    <div nz-col *ngIf="timesheetSearchForm.controls['payPeriod']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a service period'">
          <div style="width: 100%;" class="filters">
            <ppl-dropdown-select formControlName="payPeriod" id="payPeriod" placeholder="Service Period"
            [options]="payPeriod" [optionLabel]="'payPeriod'" [optionValue]="'payrollId'">
            </ppl-dropdown-select>
          </div>
        </nz-form-control>
      </nz-form-item>
    </div>
    }

    <div nz-col *ngIf="timesheetSearchForm.controls['consumer']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter consumer name'">
          <input placeholder="Consumer Name" nz-input (input)="onInput($event, 'consumer')" formControlName="consumer"
            id="consumer" aria-autocomplete="none" />

        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['consumerPplId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter Consumer PPL ID'">
          <input placeholder="Consumer PPL ID" nz-input (input)="onInput($event, 'consumerPplId')"
            formControlName="consumerPplId" aria-autocomplete="none" id="consumerPplId" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['provider']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter provider name'">
          <input placeholder="Provider Name" nz-input (input)="onInput($event, 'provider')" formControlName="provider"
            id="provider" aria-autocomplete="none" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['providerPplId']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter Provider PPL ID'">
          <input placeholder="Provider PPL ID" nz-input (input)="onInput($event, 'providerPplId')"
            formControlName="providerPplId" id="providerPplId" aria-autocomplete="none" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['paymentDate']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a payment date'">
          <div style="width: 100%;">
            <ppl-dropdown-select formControlName="paymentDate" id="paymentDate" placeholder="Pay Period"
            [options]="payPeriod" [optionLabel]="'payPeriod'" [optionValue]="'payrollId'">
            </ppl-dropdown-select>
          </div>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['chequeNumber']" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="6"
      [nzXl]="6" [nzXXl]="6" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please enter check number'">
          <div style="display: flex; gap: 4px; align-items: center;">
            <ppl-multiselect formControlName="chequeNumber" id="chequeNumber" [options]="chequeNumbers" [disabled]="false"
            [showClear]="true" [placeholder]="'Check Number'" [ariaLabel]="'Check Number'" style="width: 100%;">
          </ppl-multiselect>
            <ppl-button [ariaLabel]="'Search Check Number(Please enter Provider PPLId and Consumer PPLId to search)'" label="" icon="fa fa-search" style="margin-top: -2px;" [customClass]="'ghost-button'"
              [iconPosition]="'left'" (click)="onSearchChequeClick()"></ppl-button>
          </div>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['serviceCode']" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="6" [nzXXl]="6" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Service Code'">
          <div style="width: 100%;" class="filters">
            <ppl-dropdown-select formControlName="serviceCode" id="payPeriod" placeholder="Service Code"
            [options]="timesheetServiceCodes" [optionLabel]="'lkpValueName'" [optionValue]="'lkpValueCode'">
            </ppl-dropdown-select>
          </div>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['processCode'] && processCodes" [nzXs]="24" [nzSm]="12" [nzMd]="8"
      [nzLg]="4" [nzXl]="7" [nzXXl]="7" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control [nzErrorTip]="'Please select a Process Code'">
          <div style="width: 100%;" class="filters">
            <ppl-dropdown-select formControlName="processCode"
            id="processCode" placeholder="Process Code"
            [options]="processCodes" [optionLabel]="'displayName'" [optionValue]="'processCodeDetailId'">
            </ppl-dropdown-select>
          </div>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col *ngIf="timesheetSearchForm.controls['assignedTo']" [nzXs]="12" [nzSm]="12" [nzMd]="8" [nzLg]="4"
      [nzXl]="3" [nzXXl]="3" style="margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <nz-form-control>
          <nz-select formControlName="assignedTo" id="assignedTo" nzPlaceHolder="Assignee"
            nzShowSearch nzAllowClear style="width: 100%;">
            <nz-option nzLabel="Unassigned" nzValue="ua"></nz-option>
            <nz-option *ngFor="let user of assignedToUsers" [nzLabel]="user" [nzValue]="user">
            </nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <!-- Search Button (Always aligned right) -->
    <div nz-col [nzSpan]="24" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="3" [nzXXl]="3"
      style="text-align: right; margin-left: 8px; margin-right: 8px;">
      <nz-form-item>
        <ppl-button label="Search" icon="fa fa-filter" style="margin-top: -2px;" [customClass]="'ghost-button'"
          [iconPosition]="'left'" (click)="search()"
          *authorize="[pageId, tabId, 'AddTimeenties', 'section', 'edit']"></ppl-button>
      </nz-form-item>
    </div>

  </div>
  <div class="alert alert-danger" *ngIf="showErrors" role="alert"><strong>Error:</strong> Please enter provider PPL id and consumer
    PPL id</div>
  <div *ngIf="servicePeriodMissing" style="color: #ff4d4f; font-size: 14px; margin-bottom: 16px; margin-left: 8px;">Service Period is mandatory for the selected timeframe.</div>
</form>